import { render } from "./heatingGhController.vue?vue&type=template&id=64db4e9a&scoped=true"
import script from "./heatingGhController.vue?vue&type=script&lang=js"
export * from "./heatingGhController.vue?vue&type=script&lang=js"

import "./heatingGhController.vue?vue&type=style&index=0&id=64db4e9a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64db4e9a"]])

export default __exports__